export function isEmpty(obj) {
  for (var x in obj) {
    return false;
  }
  return true;
}

export function nth(d) {
  if(d>3 && d<21) return 'th';
  switch (d % 10) {
    case 1:  return "st";
    case 2:  return "nd";
    case 3:  return "rd";
    default: return "th";
  }
}
